<!--
 * @Author: 单译 2694138418@qq.com
 * @Date: 2022-11-23 15:25:53
 * @LastEditors: 单译 2694138418@qq.com
 * @LastEditTime: 2022-12-12 19:26:02
 * @FilePath: \music\src\components\dialog\tips.vue
 * @Description: 
 * 
 * Copyright (c) 2022 by 单译 2694138418@qq.com, All Rights Reserved. 
-->
<template>
    <div class="delAndToggle">
        <el-dialog :modal-append-to-body="false" custom-class="delCarMusic" :close-on-click-modal="false"
            :visible.sync="dialogVisible" :title="title" @close="close" width="540px">
            <!-- 转账汇款 -->
            <span v-if="dialogType == 'Transfer'">请使用您账号认证的主体 ({{ subjectInfo.type ==
                    1 ? subjectInfo.real_name : subjectInfo.company_name
            }})进行付款，完成付款后的授权书，以及发票抬头，都将使用该主体提供给您。</span>
            <span v-else-if="dialogType == 'attestation'">
                <!-- 个人认证 -->
                实名认证信息需要对应到您采购付款方，音乐版权授权书的被授权主体，以及开具发票的发票抬头。请谨慎选择，一经确认无法修改
            </span>
            <span v-else-if="dialogType == 'logout'">
                <!-- 注销 -->
                您的账号注销成功，平台已将您的数据全部清理，感谢您的使用~
            </span>
            <p v-else-if="dialogType == 'approve'" class="approve">
                <span>购买前，您需要先完成身份验证</span>
                <span>实名认证信息将作为后续采购音乐版权的授权主体，以及开具发票的发票抬头</span>
            </p>
            <p v-else-if="dialogType == 'look'">授权书签发中，请耐心等待。我们在处理完毕后将以短信的形式通知您~</p>
            <p v-else-if="dialogType == 'apply'">发票开具中，请耐心等待。我们在处理完毕后将以短信的形式通知您~</p>
            <div slot="footer" class="dialog-footer">
                <el-checkbox v-model="checked" v-if="dialogType == 'Transfer'">不再提醒</el-checkbox>
                <span v-else></span>
                <div>
                    <el-button plain @click="close" v-if="closeText != ''">{{ closeText }}</el-button>
                    <el-button type="primary" @click="iKnow" :disabled="disabled">{{ submitText }}</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            dialogVisible: false,
            checked: false,
            disabled: false,
            subjectInfo: {}
        }
    },
    props: {
        title: {
            type: String,
            default: () => '购买提醒'
        },
        closeText: {
            type: String,
            default: () => '取消'
        },
        submitText: {
            type: String,
            default: () => '我知道了'
        },
        dialogType: {
            type: String,
            default: () => 'Transfer' //默认是点击转账汇款
        },
    },
    watch: {
        dialogVisible(val) {
            if (val) {
                this.disabled = false
                if (this.dialogType == 'Transfer') {
                    this.$home.getAttestat().then(res => {
                        if (res.code == 200) {
                            this.subjectInfo = res.data
                        }
                    })
                }

            }
        },
    },
    methods: {
        iKnow() {
            this.disabled = true
            this.dialogVisible = false
            this.$emit('faClick', this.checked)
        },
        close() {
            this.dialogVisible = false
            if (this.dialogType == 'logout') {
                this.$emit('faClick', this.checked)
            }
        }
    }

}
</script>
<style lang="scss" scoped>
.delAndToggle {
    ::v-deep .el-dialog__title {
        font-weight: 600;
    }

    ::v-deep .el-dialog__header {
        padding: 20px 0 16px;
        margin: 0 20px;
        border-bottom: 1px solid #F2F2F2;
    }
}

.dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.approve {
    span {
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    span:nth-child(1) {
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        display: block;
        margin-bottom: 6px;
    }

}
</style>